module.exports = __webpack_public_path__ + "img/tip3.3f7a0d9b.png";